import type { Candle as ChartCandle } from '../../sim/PriceChart';
import { createElement } from 'react';
import { Navigate } from 'react-router-dom';

export const STUDIO_HOME_PATH = '/indicator-studio';
export const STUDIO_EDIT_PATH = '/indicator-studio/edit';
export const STUDIO_MY_INDICATORS_PATH = `${STUDIO_HOME_PATH}?segment=my`;
export const LEGACY_MY_INDICATORS_REDIRECT = STUDIO_MY_INDICATORS_PATH;

export function LegacyMyIndicatorsRedirect() {
  return createElement(Navigate, { to: LEGACY_MY_INDICATORS_REDIRECT, replace: true });
}

export type StudioContext = Readonly<{ symbol: string; stockName: string; candles: ChartCandle[] }>;
export type StudioEntryState = Partial<StudioContext> & {
  studioEntry?: 'blank';
};

export function studioEditPath(options: { templateId?: string; itemId?: string; resume?: boolean; ai?: boolean } = {}): string {
  const params: string[] = [];
  if (options.templateId) params.push(`template=${encodeURIComponent(options.templateId)}`);
  if (options.itemId) params.push(`item=${encodeURIComponent(options.itemId)}`);
  if (options.resume) params.push('resume=1');
  if (options.ai) params.push('ai=1');
  const query = params.join('&');
  return query ? `${STUDIO_EDIT_PATH}?${query}` : STUDIO_EDIT_PATH;
}

export function studioItemEditPath(itemId: string): string {
  return studioEditPath({ itemId });
}

export function shouldRedirectEmptyStudioEdit(search: string, state: unknown, hasDraft: boolean): boolean {
  if (hasDraft || new URLSearchParams(search).size > 0) return false;
  return !(state && typeof state === 'object' && (state as StudioEntryState).studioEntry === 'blank');
}
